import axios from 'axios';

const ENDPOINT =
    '/actions/mg-motors-europe-module/site-controller/resolve-brand-store-by-retailer-id';

// Resolved via an /actions/ endpoint (never baked into the FastCGI-cached page)
// so the dealer/Salesforce code lookup stays server-side while the result still
// varies per visitor's own `retailerid`.
export const resolveBrandStoreSlugByRetailerId = (retailerId, siteHandle) =>
    axios
        .get(ENDPOINT, { params: { retailerid: retailerId, siteHandle } })
        .then((res) => res.data?.slug ?? null)
        .catch(() => null);
